import { ProjectionRelation } from './projection-relation';

/**
 * Api request projection
 * Controls which fields and nested data are returned in the response
 *
 * Example usage:
 * {
 *   "root": {
 *     "fields": ["uuid", "name", "type"]
 *   },
 *   "featureItems": {
 *     "fields": ["uuid", "title", "key"],
 *     "filters": [
 *       {
 *         "field": "key",
 *         "operation": "in",
 *         "value": ["seats", "doors"]
 *       }
 *     ]
 *   },
 *   "quotation": {
 *     "fields": ["computedTotalGross"],
 *     "relations": {
 *       "pricingItems": {
 *         "fields": ["description", "unitsTotalGross"]
 *       }
 *     }
 *   },
 *   "files": {
 *     "fields": ["uuid", "name"]
 *   }
 * }
 */
export class ApiRequestProjection {
	/**
	 * Root level field selection
	 */
	root?: ProjectionRelation;

	/**
	 * Named relations and their projection configurations
	 * Key is the relation name (e.g., 'featureItems', 'files', 'quotation')
	 */
	[relationName: string]: ProjectionRelation | undefined;
}
